const myCustomizeV2Api = (function(){
    return {
        "MfaEmailPhoneLoginUrl": async function  (host,params) {
            let res = await fetch(host + '/account/api/v2/user/login', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "GetShopifyBindInfo": async function  (host,token) {
            let res = await fetch(host + '/shopify/api/v1/info', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                    'Authorization': token  // 设置 Authorization 头部
                },
                body: JSON.stringify({})
            })
            const result = await res.json()
            return result
        },
        "MultipassLogin": function (multipass, region) {
            let login_url = "/account/login/multipass/"
            let region_dict = {
                "CA": "https://ca.switch-bot.com",
                "GB": "https://uk.switch-bot.com",
                "EU": "https://eu.switch-bot.com",
                "JP": "https://www.switchbot.jp",
                "US": "https://us.switch-bot.com",
                "GLOBAL": "https://www.switch-bot.com",
                "TEST": "https://xyz.switch-bot.com",
            }
            let region_url = region_dict[region]
            console.log(region_url + login_url + multipass,'region_url + login_url + multipass')
            window.location.href = region_url + login_url + multipass
        },
        "MfaEmailPhoneSendCode": async function  (host,params) {
            let res = await fetch(host + '/account/api/v2/verification/code/send', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "MfaSearchLoginTypeUrl": async function  (host,params) {
            let res = await fetch(host + '/account/api/v1/user/mfa/privacy', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "MfaEmailPhoneCheckCode": async function  (host,params) {
            let res = await fetch(host + '/account/api/v1/auth/check', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "MfaTwoStepVerifyTokenUrl": async function  (host,params) {
            let res = await fetch(host + '/account/api/v1/user/mfa/verify', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "TrustDeviceGetBotRegionUrl": async function  (host,params,token) {
            let res = await fetch(host + '/account/api/v1/user/userinfo', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "ResetPwdToOtherDeviceLogout": async function  (host,params,token) {
            let res = await fetch(host + '/v2/mobile/management/resetPwd', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "AfterRegisterSetSubscribeNotifyEnabel": async function  (host,params,token) {
            let res = await fetch(host + '/msgcenter/api/v1/notify/enable', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "MfaTrustDeviceLoginUrl": async function  (host,params,token) {
            let res = await fetch(host + '/v2/mobile/management/login', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "MfaTrustDeviceSetUrl": async function  (host,params,token) {
            let res = await fetch(host + '/v2/mobile/management/trust', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "CheckPhoneOrEmailExistUrl": async function  (host,params) {
            let res = await fetch(host + '/account/api/v2/user/exist', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "EmailOrPhoneRegisterUrl": async function  (host,params) {
            let res = await fetch(host + '/account/api/v2/user/register', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "EmailOrPhoneForgetPwdUrl": async function  (host,params) {
            let res = await fetch(host + '/account/api/v3/user/password/forgot', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "PhoneGetCountryCodeUrl": async function  (host,url) {
            let res = await fetch(host + url, {
                method: 'GET',
                headers: {  
                    'Content-Type': 'application/json',
                },  
            })
            const result = await res.json()
            return result
        },
        "CheckPhoneOrEmailBindUrl": async function  (host,params) {
            let res = await fetch(host + '/account/api/v1/bind/check', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "AccountBindSendEmailV1": async function (host, params) {
            let res = await fetch(host + '/account/api/v1/verify/code', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "BindExistAccountV1": async function (host, params, token) {
            let res = await fetch(host + '/shopify/api/v1/bind', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                    'Authorization': token,  // 设置 Authorization 头部
                },
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "ManualSendEmailCode": async function (host, params) {
            let res = await fetch(host + '/account/api/v1/verify/code/inactive', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
        "ManualSendEmailCodeISInactive": async function (host, params) {
            let res = await fetch(host + '/account/api/v1/verify/code/inactive/status', {
                method: 'POST',
                headers: {  
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify(params)
            })
            const result = await res.json()
            return result
        },
    }
})()